import { render } from "./HistoryColis.vue?vue&type=template&id=39f6687c&scoped=true&ts=true"
import script from "./HistoryColis.vue?vue&type=script&lang=ts"
export * from "./HistoryColis.vue?vue&type=script&lang=ts"

import "./HistoryColis.vue?vue&type=style&index=0&id=39f6687c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f6687c"]])

export default __exports__